import ConfirmClickButton, { CONFIRM_CLICK_LABEL } from './ConfirmClickButton';

export const LOGOUT_CONFIRM_LABEL = CONFIRM_CLICK_LABEL;

const LogoutButton = ({ onLogout, ...rest }) => (
  <ConfirmClickButton
    onConfirm={onLogout}
    confirmTitle="Çıkış yap"
    confirmDescription="Oturumunuzu kapatmak istediğinize emin misiniz?"
    confirmStep2Description="Son onay: çıkış yapmak için tekrar onaylayın."
    confirmLabel="Evet, Çıkış Yap"
    confirmTone="warning"
    {...rest}
  />
);

export default LogoutButton;
